/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import React, { useEffect, useRef } from 'react'

/**
 * Use setTimeout with Hooks in a declarative way.
 */


export function useTimeout(
  callback: React.EffectCallback,
  delay: number | null
): React.MutableRefObject<number | null> {
  const timeoutRef = useRef<number | null>(null)
  const callbackRef = useRef(callback)

  // Remember the latest callback
  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  // Set up the timeout
  useEffect(() => {
    if (typeof delay === 'number') {
      timeoutRef.current = window.setTimeout(() => callbackRef.current(), delay)

      // Clear timeout if the component is unmounted or the delay changes
      return () => {
        window.clearTimeout(timeoutRef.current || 0)
      }
    }
  }, [delay])

  return timeoutRef
}
